import { Route, Routes } from 'react-router-dom';
import TransportList from './transport-list';
import TransportJobOverview from './transport-job-overview/transport-job-overview';

const TransportRouting = () => {
  return (
    <Routes>
      <Route path='' element={<TransportList />} />
      {/* Before the :uid route on purpose — a static segment must not be read
          as a job id. React Router ranks it higher, and being explicit here
          means a future rename cannot quietly break it. */}
      <Route path='batches' element={<TransportList />} />
      {/* The address batches used to have. Kept so a bookmark still works. */}
      <Route path='runs' element={<TransportList />} />
      <Route path=':uid' element={<TransportJobOverview />} />
    </Routes>
  );
};

export default TransportRouting;
